// @tidal-export

import { validateTidalLicense } from '@workwave-tidal/core/base'

export { FilePreview } from './FilePreview.js'
export { FilePreviewThumbnail } from './components/FilePreviewThumbnail.js'
export { FilePreviewMimeTypeIcon } from './components/StandardFilePreview/components/FilePreviewMimeTypeIcon.js'
export { FilePreviewSubtitle } from './components/StandardFilePreview/components/FilePreviewSubtitle.js'
export { FilePreviewTitle } from './components/StandardFilePreview/components/FilePreviewTitle.js'

export type {
  AllowedImageAttributes,
  FilePreviewProps,
  FilePreviewThumbnailProps,
  ImageFilePreviewProps,
  StandardFilePreviewProps,
} from './types.js'

export {
  mimeType,
  type MimeType,
} from './mimeType.js'

// #license-validation
validateTidalLicense()
